<template>
  <div class="brand-mark" aria-label="SafetyVision">
    <svg viewBox="0 0 42 42" role="img" aria-hidden="true">
      <defs>
        <linearGradient id="shield-gradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stop-color="#7c5cff" />
          <stop offset="1" stop-color="#35b8ff" />
        </linearGradient>
      </defs>
      <path fill="url(#shield-gradient)" d="M21 2.8 36 8.5v10.9c0 9.6-6.1 16.7-15 20-8.9-3.3-15-10.4-15-20V8.5L21 2.8Z" />
      <path fill="#fff" d="m13.2 20.7 4.7 4.6 10.8-11 2.6 2.7-13.4 13.4-7.3-7.2 2.6-2.5Z" />
    </svg>
  </div>
</template>
